import React, { useCallback, useState } from 'react';

import { Avatar, Button, Flex, Typography } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import logoMyEduzz from 'components/Icon/images/app-eduzz-logo.png';
import { isIOS } from 'v2/helpers/isIOS';
import { useIsAppWebview } from 'v2/hooks/useIsAppWebview';


const AppAlert = () => {
  const [open, setOpen] = useState<boolean>(true);
  const isAppWebview = useIsAppWebview();

  const goToApp = () => {
    if (isIOS())
      return window.open('https://apps.apple.com/br/app/eduzz-neg%C3%B3cios-digitais/id1079845439', '_blank');

    return window.open('https://play.google.com/store/apps/details?id=com.eduzzmobile.mobile', '_blank');
  };

  const onClose = useCallback<React.MouseEventHandler<HTMLButtonElement | HTMLElement>>(e => {
    e.stopPropagation();
    return setOpen(false);
  }, []);

  if (!open || isAppWebview) return null;

  return (
    <Flex className='md:hidden'>
      <Flex
        align='center'
        justify='space-between'
        className='fixed bottom-0 z-10 flex w-full bg-(--uizz-antd-color-bg-mask) p-(--uizz-antd-padding) backdrop-blur-sm md:hidden'
        onClick={goToApp}
      >
        <Flex align='center' gap='small'>
          <Button
            type='text'
            shape='circle'
            icon={<Icon.X  />}
            className='z-99999 text-(--uizz-antd-color-white)!'
            onClick={onClose}
          />
          <Avatar shape='square' size={45} src={logoMyEduzz} alt='APP Eduzz' />
          <Flex vertical>
            <Typography.Text strong className='text-(--uizz-antd-color-white)!'>
              Toque e experimente o App Eduzz!
            </Typography.Text>
            <Typography.Text className='text-(--uizz-antd-color-white)!'>
              A gestão do seu negócio, na palma da mão.
            </Typography.Text>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default AppAlert;
